/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Trigger_EventInputs */

const cs_form_trigger_event = /** @type {(inputs: Form_Trigger_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spouštěcí událost`)
};

const en_form_trigger_event = /** @type {(inputs: Form_Trigger_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger event`)
};

/**
* | output |
* | --- |
* | "Trigger event" |
*
* @param {Form_Trigger_EventInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_trigger_event = /** @type {((inputs?: Form_Trigger_EventInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Trigger_EventInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_trigger_event(inputs)
	return cs_form_trigger_event(inputs)
});